var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileImageEditing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m43 20.433-3.464-2a2 2 0 0 0-2.732.731L26.719 36.633a4 4 0 0 0-.535 2.066l.055 3.333a2 2 0 0 0 2.971 1.716l2.915-1.619a3.986 3.986 0 0 0 1.522-1.5l10.085-17.465A2 2 0 0 0 43 20.433zm-11.085 19.2a1.993 1.993 0 0 1-.761.747L28.239 42l-.055-3.332a2.016 2.016 0 0 1 .267-1.035l10.085-17.467 3.464 2zM41 32.9a1 1 0 0 0-1 1V37a3.027 3.027 0 0 1-3.1 3 .959.959 0 0 0-.95 1A1.044 1.044 0 0 0 37 42a5.006 5.006 0 0 0 5-5v-3.1a1 1 0 0 0-1-1z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.22 40H9a3 3 0 0 1-3-3v-4.586l4.877-4.877a3.007 3.007 0 0 1 4.246 0l1.76 1.76a3 3 0 0 0 4.234 0l5.76-5.76a3 3 0 0 1 3.942-.255A1 1 0 1 0 32.04 21.7a5 5 0 0 0-6.577.425l-5.76 5.76a1 1 0 0 1-1.406 0l-1.76-1.76a5.008 5.008 0 0 0-7.074 0L6 29.586V9a3 3 0 0 1 3-3h28a3 3 0 0 1 3 3v6.82a1 1 0 0 0 2 0V9a5.006 5.006 0 0 0-5-5H9a5.006 5.006 0 0 0-5 5v28a5.006 5.006 0 0 0 5 5h14.22a1 1 0 0 0 0-2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15a5 5 0 1 0 5-5 5.006 5.006 0 0 0-5 5zm8 0a3 3 0 1 1-3-3 3 3 0 0 1 3 3z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImageEditing);
export default __webpack_public_path__ + "static/media/profile_image_editing.9b8c12b367dbe502e184970614f0b103.svg";
export { ForwardRef as ReactComponent };